import styled, { css } from 'styled-components';
import _ from 'lodash';

import {withCssUnit} from "common/components/styleguide/utils";
import Link from "common/components/styleguide/Link";


const SS = {};

SS.FilterSection = styled.div`
  margin-bottom: ${({ theme }) => _.get(theme, 'filters.section.marginBottom', '15px')};
  padding-bottom: ${({ theme }) => _.get(theme, 'filters.section.paddingBotton', '15px')};
  border-bottom: ${({ theme }) => _.get(theme, 'filters.section.borderBottom')};
  ${({ isLast }) =>
    isLast &&
    css`
      margin-bottom: ${({ theme }) => _.get(theme, 'filters.section.last.marginBottom', '15px')};
      padding-bottom: ${({ theme }) => _.get(theme, 'filters.section.last.paddingBottom', '15px')};
    `};

  @media (max-width: ${({ theme }) => withCssUnit(theme.breakpoints.md)}) {
    border-bottom: ${({ theme }) => _.get(theme, 'filters.mobile.section.borderBottom')};
  }

  &:last-child {
    margin-bottom: 0;
    padding-bottom: 0;
    border-bottom: none;
  }
`;

SS.ShowMore = styled(Link)`
  && {
    font-size: 0.85em;
    margin-top: ${({ theme }) => _.get(theme, 'filters.item.marginTop', '10px')};
    margin-bottom: ${({ theme }) => _.get(theme, 'filters.item.marginBottom', '10px')};
    display: block;
  }
`;

SS.LabelText = styled.span`
  font-size: 0.9em;
  display: flex;
  align-items: center;
  color: ${({ theme }) => _.get(theme, 'filters.mobile.color', '#34495e')};
  font-weight: ${({ theme }) => _.get(theme, 'filters.mobile.fontWeight', 'normal')};
  @media (min-width: ${({ theme }) => withCssUnit(theme.breakpoints.md)}) {
    color: ${({ theme }) => _.get(theme, 'filters.color', '#34495e')};
    font-weight: ${({ theme }) => _.get(theme, 'filters.fontWeight', 'normal')};
  }
`;

SS.ProductCount = styled.span`
  font-size: 0.8em;
  color: ${({ theme }) => _.get(theme, 'filters.count.color', '#34495e')};
`;

SS.ListItem = styled.li`
  margin-bottom: ${({ theme }) => _.get(theme, 'filters.mobile.item.marginBottom', '10px')};
  padding-right: 10px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  &:last-child {
    margin-bottom: 0;
  }
  @media (min-width: ${({ theme }) => withCssUnit(theme.breakpoints.md)}) {
    margin-bottom: ${({ theme }) => _.get(theme, 'filters.item.marginBottom', '10px')};
    padding-right: 0;
  }
`;

SS.FilterTitle = styled.h4`
  margin-top: 0;
  margin-bottom: 5px;
  font-size: ${({ theme }) => _.get(theme, 'filters.section.title.fontSize', '0.9em')};
  display: flex;
  justify-content: space-between;
  align-items: center;

  color: ${({ theme }) => _.get(theme, 'filters.mobile.section.title.color', '#34495e')};
  @media (min-width: ${({ theme }) => withCssUnit(theme.breakpoints.md)}) {
    margin-bottom: 10px;
    color: ${({ theme }) => _.get(theme, 'filters.section.title.color', '#34495e')};
  }
`;

SS.TitleIcon = styled.span`
  display: none;
  @media (max-width: ${({ theme }) => withCssUnit(theme.breakpoints.md)}) {
    display: block;
    color: ${({ theme }) => _.get(theme, 'filters.mobile.section.icon.color', '#34495e')};
    font-size: ${({ theme }) => _.get(theme, 'filters.mobile.section.icon.size', '24px')};
    height: ${({ theme }) => _.get(theme, 'filters.mobile.section.icon.size', '24px')};
  }
`;

SS.FormWrapper = styled.div`
  display: block;
  @media (max-width: ${({ theme }) => withCssUnit(theme.breakpoints.md)}) {
    display: ${({ isHidden }) => (isHidden ? 'none' : 'block')};
    margin-top: 10px;
  }
`;

export default SS;
